import {
  faBell,
  faBookOpen,
  faCheckSquare,
  faChartArea,
  faCode,
  faGem,
  faInfoCircle,
  faLink,
  faLineColumns,
  faQuestionCircle,
  faRocket,
  faServer,
  faTint,
  faTrafficLight,
  faTelescope,
  faUser,
  faUserSecret,
  faUsers,
  faPipeValve,
  faWebhook,
  faCogs,
} from "@fortawesome/pro-solid-svg-icons";

import {
  faNodeJs,
  faJsSquare,
  faPython,
  faGolang,
  faJava,
  faPhp,
} from "@fortawesome/free-brands-svg-icons";

const navigationLinks = [
  {
    name: "Overview",
    sub_sections: [
      {
        name: "Getting started",
        icon: faRocket,
        link: "/",
      },
      {
        name: "FAQs",
        icon: faQuestionCircle,
        link: "/faq.html",
      },
      {
        name: "Guides",
        icon: faBookOpen,
        activePath: "/guides",
        pages: [
          {
            name: "Start",
            link: "/guides.html",
          },
          {
            name: "Add a new application",
            link: "/guides/new-application.html",
          },
          {
            name: "Configuration",
            link: "/guides/configuration.html",
          },
          {
            name: "Reporting deploys",
            link: "/guides/deploy-markers.html",
          },
          {
            name: "Grouping with namespaces",
            link: "/guides/namespaces.html",
          },
          {
            name: "Grouping with actions",
            link: "/guides/actions.html",
          },
          {
            name: "Tagging",
            activePath: "/guides/tagging",
            pages: [
              {
                name: "Add tags",
                link: "/guides/tagging.html",
              },
              {
                name: "Attribute distributions",
                link: "/guides/tagging/attribute-distributions.html",
              },
            ],
          },
          {
            name: "Customization",
            activePath: "/guides/custom-data",
            pages: [
              {
                name: "Start",
                link: "/guides/custom-data.html",
              },
              {
                name: "Request parameters",
                link: "/guides/custom-data/request-parameters.html",
              },
              {
                name: "Request session data",
                link: "/guides/custom-data/request-session-data.html",
              },
              {
                name: "Request headers",
                link: "/guides/custom-data/request-headers.html",
              },
              {
                name: "Function parameters",
                link: "/guides/custom-data/function-parameters.html",
              },
              {
                name: "Custom data",
                link: "/guides/custom-data/custom-data.html",
              },
            ],
          },
          {
            name: "Filtering application data",
            activePath: "/guides/filter-data",
            pages: [
              {
                name: "Start",
                link: "/guides/filter-data.html",
              },
              {
                name: "Parameter filtering",
                link: "/guides/filter-data/filter-parameters.html",
              },
              {
                name: "Session data filtering",
                link: "/guides/filter-data/filter-session-data.html",
              },
              {
                name: "Request header collection",
                link: "/guides/filter-data/filter-headers.html",
              },
              {
                name: "Function parameter filtering",
                link: "/guides/filter-data/filter-function-parameters.html",
              },
              {
                name: "Ignore errors",
                link: "/guides/filter-data/ignore-errors.html",
              },
              {
                name: "Ignore actions",
                link: "/guides/filter-data/ignore-actions.html",
              },
              {
                name: "Ignore namespaces",
                link: "/guides/filter-data/ignore-namespaces.html",
              },
              {
                name: "Ignore logs",
                link: "/guides/filter-data/ignore-logs.html",
              },
            ],
          },
          {
            name: "Find slow queries",
            link: "/guides/slow-queries.html",
          },
          {
            name: "Instrumentation",
            activePath: "/guides/instrumentation",
            pages: [
              {
                name: "Additional OpenTelemetry instrumentation",
                link: "/guides/instrumentation/additional-opentelemetry-instrumentation.html",
              },
            ],
          },
          {
            name: "Application management",
            activePath: "/guides/application",
            pages: [
              {
                name: "Multiple applications on one host",
                link: "/guides/application/multiple-applications-on-one-host.html",
              },
              {
                name: "Migrating applications",
                link: "/guides/application/migrating-applications.html",
              },
              {
                name: "Removing applications",
                link: "/guides/application/deleting-applications.html",
              },
            ],
          },
        ],
      },
      {
        name: "Your applications",
        icon: faServer,
        activePath: "/application",
        pages: [
          {
            name: "Overview",
            link: "/application.html",
          },
          {
            name: "Configuration",
            link: "/application/configuration.html",
          },
          {
            name: "Namespaces",
            link: "/application/namespaces.html",
          },
          {
            name: "Tagging",
            link: "/application/tagging.html",
          },
          {
            name: "Metadata",
            link: "/application/metadata.html",
          },
          {
            name: "Markers",
            activePath: "/application/markers",
            pages: [
              {
                name: "Overview",
                link: "/application/markers.html",
              },
              {
                name: "Deploy markers",
                link: "/application/markers/deploy-markers.html",
              },
              {
                name: "Custom markers",
                link: "/application/markers/custom-markers.html",
              },
            ],
          },
          {
            name: "Customizing data collection",
            link: "/application/data-collection.html",
          },
          {
            name: "Parameter filtering",
            link: "/application/parameter-filtering.html",
          },
          {
            name: "Session data filtering",
            link: "/application/session-data-filtering.html",
          },
          {
            name: "Request header collection",
            link: "/application/header-filtering.html",
          },
          {
            name: "Application settings",
            link: "/application/settings.html",
          },
          {
            name: "Notification settings",
            link: "/application/notification-settings.html",
          },
          {
            name: "Link templates",
            link: "/application/link-templates.html",
          },
          {
            name: "Backtrace links",
            link: "/application/backtrace-links.html",
          },
          {
            name: "Integrations",
            activePath: "/application/integrations",
            pages: [
              {
                name: "Overview (full list)",
                link: "/application/integrations.html",
              },
              {
                name: "Asana",
                link: "/application/integrations/asana.html",
              },
              {
                name: "Discord",
                link: "/application/integrations/discord.html",
              },
              {
                name: "Geckoboard",
                link: "/application/integrations/geckoboard.html",
              },
              {
                name: "GitHub",
                activePath: "/application/integrations/github/",
                pages: [
                  {
                    name: "Overview",
                    link: "/application/integrations/github.html",
                  },
                  {
                    name: "Link AppSignal to repo",
                    link: "/application/integrations/github/link-to-repo.html",
                  },
                  {
                    name: "Link backtraces to revisions and lines",
                    link: "/application/integrations/github/link-backtraces-to-revisions-and-lines.html",
                  },
                  {
                    name: "Create GitHub Issues",
                    link: "/application/integrations/github/create-github-issue.html",
                  },
                ],
              },
              {
                name: "GitLab",
                link: "/application/integrations/gitlab.html",
              },
              {
                name: "Google Hangouts Chat",
                link: "/application/integrations/hangouts.html",
              },
              {
                name: "Jira",
                link: "/application/integrations/jira.html",
              },
              {
                name: "Linear",
                link: "/application/integrations/linear.html",
              },
              {
                name: "Microsoft Teams",
                link: "/application/integrations/teams.html",
              },
              {
                name: "OpsGenie",
                link: "/application/integrations/opsgenie.html",
              },
              {
                name: "PagerDuty",
                link: "/application/integrations/pagerduty.html",
              },
              {
                name: "Phabricator",
                link: "/application/integrations/phabricator.html",
              },
              {
                name: "Pivotal Tracker",
                link: "/application/integrations/pivotal-tracker.html",
              },
              {
                name: "Shortcut",
                link: "/application/integrations/shortcut.html",
              },
              {
                name: "Slack",
                link: "/application/integrations/slack.html",
              },
              {
                name: "Squadcast",
                link: "/application/integrations/squadcast.html",
              },
              {
                name: "Trello",
                link: "/application/integrations/trello.html",
              },
              {
                name: "Webhooks",
                link: "/application/integrations/webhooks.html",
              },
            ],
          },
          {
            name: "Environment metadata",
            link: "/application/environment-metadata.html",
          },
        ],
      },
      {
        name: "Your organizations",
        icon: faUsers,
        activePath: "/organization",
        pages: [
          {
            name: "Overview",
            link: "/organization.html",
          },
          {
            name: "Team management",
            activePath: "/organization/team",
            pages: [
              {
                name: "Manage members",
                link: "/organization/team/members.html",
              },
              {
                name: "Manage owners",
                link: "/organization/team/owners.html",
              },
              {
                name: "Manage teams",
                link: "/organization/team/teams.html",
              },
            ],
          },
          {
            name: "Notifier management",
            link: "/organization/notifier-management",
          },
          {
            name: "Data exports",
            link: "/organization/data-exports",
          },
          {
            name: "2FA Enforcement",
            link: "/organization/two-factor-authentication-enforcement.html",
          },
        ],
      },
      {
        name: "Your user account",
        icon: faUser,
        activePath: "/user-account",
        pages: [
          {
            name: "Overview",
            link: "/user-account.html",
          },
          {
            name: "Email addresses",
            link: "/user-account/email-addresses.html",
          },
          {
            name: "Two-factor authentication",
            link: "/user-account/two-factor-authentication.html",
          },
        ],
      },
    ],
  },
  {
    name: "Languages",
    sub_sections: [
      {
        name: "AppSignal for Ruby",
        icon: faGem,
        activePath: "/ruby",
        pages: [
          {
            name: "Overview",
            link: "/ruby.html",
          },
          {
            name: "Installation",
            activePath: "/ruby/installation",
            pages: [
              {
                name: "Overview",
                link: "/ruby/installation.html",
              },
              {
                name: "Upgrading from 3 to 4",
                link: "/ruby/installation/upgrade-from-3-to-4.html",
              },
              {
                name: "Upgrading from 2 to 3",
                link: "/ruby/installation/upgrade-from-2-to-3.html",
              },
            ],
          },
          {
            name: "Configuration",
            activePath: "/ruby/configuration",
            pages: [
              {
                name: "Overview",
                link: "/ruby/configuration.html",
              },
              {
                name: "Options",
                link: "/ruby/configuration/options.html",
              },
              {
                name: "Load order",
                link: "/ruby/configuration/load-order.html",
              },
            ],
          },
          {
            name: "Integrations",
            activePath: "/ruby/integrations",
            pages: [
              {
                name: "Overview",
                link: "/ruby/integrations.html",
              },
              {
                name: "Active Job",
                link: "/ruby/integrations/active-job.html",
              },
              {
                name: "Action Cable",
                link: "/ruby/integrations/action-cable.html",
              },
              {
                name: "Capistrano",
                link: "/ruby/integrations/capistrano.html",
              },
              {
                name: "DataMapper",
                link: "/ruby/integrations/datamapper.html",
              },
              {
                name: "Delayed::Job",
                link: "/ruby/integrations/delayed-job.html",
              },
              {
                name: "Elasticsearch",
                link: "/ruby/integrations/elasticsearch.html",
              },
              {
                name: "Garbage Collection",
                link: "/ruby/integrations/garbage-collection.html",
              },
              {
                name: "Global VM Lock",
                link: "/ruby/integrations/global-vm-lock.html",
              },
              {
                name: "Grape",
                link: "/ruby/integrations/grape.html",
              },
              {
                name: "GraphQL",
                link: "/ruby/integrations/graphql.html",
              },
              {
                name: "Hanami",
                link: "/ruby/integrations/hanami.html",
              },
              {
                name: "HTTP.rb",
                link: "/ruby/integrations/http.html",
              },
              {
                name: "MongoDB",
                link: "/ruby/integrations/mongodb.html",
              },
              {
                name: "Multiple Rack libraries",
                link: "/ruby/integrations/rack-libraries.html",
              },
              {
                name: "Net::HTTP",
                link: "/ruby/integrations/net-http.html",
              },
              {
                name: "Ownership",
                link: "/ruby/integrations/ownership.html",
              },
              {
                name: "Padrino",
                link: "/ruby/integrations/padrino.html",
              },
              {
                name: "Puma",
                link: "/ruby/integrations/puma.html",
              },
              {
                name: "Que",
                link: "/ruby/integrations/que.html",
              },
              {
                name: "Rack",
                link: "/ruby/integrations/rack.html",
              },
              {
                name: "Rake",
                link: "/ruby/integrations/rake.html",
              },
              {
                name: "Redis",
                link: "/ruby/integrations/redis.html",
              },
              {
                name: "Resque",
                link: "/ruby/integrations/resque.html",
              },
              {
                name: "Ruby on Rails",
                link: "/ruby/integrations/rails.html",
              },
              {
                name: "Ruby VM",
                link: "/ruby/integrations/ruby-vm.html",
              },
              {
                name: "Sequel",
                link: "/ruby/integrations/sequel.html",
              },
              {
                name: "Shoryuken",
                link: "/ruby/integrations/shoryuken.html",
              },
              {
                name: "Sidekiq",
                link: "/ruby/integrations/sidekiq.html",
              },
              {
                name: "Sinatra",
                link: "/ruby/integrations/sinatra.html",
              },
              {
                name: "Solid Queue",
                link: "/ruby/integrations/solidqueue.html",
              },
              {
                name: "ViewComponent",
                link: "/ruby/integrations/view-component.html",
              },
              {
                name: "Webmachine",
                link: "/ruby/integrations/webmachine.html",
              },
            ],
          },
          {
            name: "Custom instrumentation",
            activePath: "/ruby/instrumentation",
            pages: [
              {
                name: "Overview",
                link: "/ruby/instrumentation.html",
              },
              {
                name: "Integrating AppSignal",
                link: "/ruby/instrumentation/integrating-appsignal.html",
              },
              {
                name: "Instrumentation",
                link: "/ruby/instrumentation/instrumentation.html",
              },
              {
                name: "Exception handling",
                link: "/ruby/instrumentation/exception-handling.html",
              },
              {
                name: "Breadcrumbs",
                link: "/ruby/instrumentation/breadcrumbs.html",
              },
              {
                name: "Ignore instrumentation",
                link: "/ruby/instrumentation/ignore-instrumentation.html",
              },
              {
                name: "Scripts and background jobs",
                link: "/ruby/instrumentation/background-jobs.html",
              },
              {
                name: "Method instrumentation",
                link: "/ruby/instrumentation/method-instrumentation.html",
              },
              {
                name: "Event formatters",
                link: "/ruby/instrumentation/event-formatters.html",
              },
              {
                name: "Minutely probes",
                link: "/ruby/instrumentation/minutely-probes.html",
              },
              {
                name: "Request queue time",
                link: "/ruby/instrumentation/request-queue-time.html",
              },
              {
                name: "Custom markers",
                link: "/ruby/instrumentation/custom-markers.html",
              },
            ],
          },
          {
            name: "Command line tools",
            activePath: "/ruby/command-line",
            pages: [
              {
                name: "Overview",
                link: "/ruby/command-line.html",
              },
              {
                name: "Install",
                link: "/ruby/command-line/install.html",
              },
              {
                name: "Diagnose",
                link: "/ruby/command-line/diagnose.html",
              },
              {
                name: "Demo",
                link: "/ruby/command-line/demo.html",
              },
            ],
          },
        ],
      },
      {
        name: "AppSignal for Elixir",
        icon: faTint,
        activePath: "/elixir",
        pages: [
          {
            name: "Overview",
            link: "/elixir.html",
          },
          {
            name: "Installation",
            activePath: "/elixir/installation",
            pages: [
              {
                name: "Overview",
                link: "/elixir/installation.html",
              },
              {
                name: "Umbrella applications",
                link: "/elixir/installation/umbrella.html",
              },
            ],
          },
          {
            name: "Configuration",
            activePath: "/elixir/configuration",
            pages: [
              {
                name: "Overview",
                link: "/elixir/configuration.html",
              },
              {
                name: "Options",
                link: "/elixir/configuration/options.html",
              },
              {
                name: "Load order",
                link: "/elixir/configuration/load-order.html",
              },
            ],
          },
          {
            name: "Integrations",
            activePath: "/elixir/integrations",
            pages: [
              {
                name: "Overview",
                link: "/elixir/integrations.html",
              },
              {
                name: "Phoenix",
                link: "/elixir/integrations/phoenix.html",
              },
              {
                name: "Plug",
                link: "/elixir/integrations/plug.html",
              },
              {
                name: "Ecto",
                link: "/elixir/integrations/ecto.html",
              },
              {
                name: "Erlang",
                link: "/elixir/integrations/erlang.html",
              },
              {
                name: "Absinthe",
                link: "/elixir/integrations/absinthe.html",
              },
              {
                name: "Finch",
                link: "/elixir/integrations/finch.html",
              },
              {
                name: "Oban",
                link: "/elixir/integrations/oban.html",
              },
              {
                name: "Tesla",
                link: "/elixir/integrations/tesla.html",
              },
            ],
          },
          {
            name: "Custom instrumentation",
            activePath: "/elixir/instrumentation",
            pages: [
              {
                name: "Overview",
                link: "/elixir/instrumentation.html",
              },
              {
                name: "Integrating AppSignal",
                link: "/elixir/instrumentation/integrating-appsignal.html",
              },
              {
                name: "Instrumentation",
                link: "/elixir/instrumentation/instrumentation.html",
              },
              {
                name: "Exception handling",
                link: "/elixir/instrumentation/exception-handling.html",
              },
              {
                name: "Minutely probes",
                link: "/elixir/instrumentation/minutely-probes.html",
              },
              {
                name: "Mix tasks",
                link: "/elixir/instrumentation/mix_tasks.html",
              },
            ],
          },
          {
            name: "Command line tools",
            activePath: "/elixir/command-line",
            pages: [
              {
                name: "Overview",
                link: "/elixir/command-line.html",
              },
              {
                name: "Install",
                link: "/elixir/command-line/install.html",
              },
              {
                name: "Diagnose",
                link: "/elixir/command-line/diagnose.html",
              },
              {
                name: "Demo",
                link: "/elixir/command-line/demo.html",
              },
              {
                name: "Check install",
                link: "/elixir/command-line/check-install.html",
              },
            ],
          },
          {
            name: "Releases",
            link: "/elixir/releases.html",
          },
          {
            name: "Why a NIF?",
            link: "/elixir/why-nif.html",
          },
        ],
      },
      {
        name: "AppSignal for Node.js",
        icon: faNodeJs,
        activePath: "/nodejs/3.x",
        pages: [
          {
            name: "Overview",
            link: "/nodejs/3.x.html",
          },
          {
            name: "Migration Guide",
            link: "/nodejs/3.x/migration-guide.html",
          },
          {
            name: "Installation",
            link: "/nodejs/3.x/installation.html",
          },
          {
            name: "Bundling with esbuild",
            link: "/nodejs/3.x/bundling-with-esbuild.html",
          },
          {
            name: "Configuration",
            activePath: "/nodejs/3.x/configuration",
            pages: [
              {
                name: "Overview",
                link: "/nodejs/3.x/configuration.html",
              },
              {
                name: "Options",
                link: "/nodejs/3.x/configuration/options.html",
              },
              {
                name: "Load order",
                link: "/nodejs/3.x/configuration/load-order.html",
              },
            ],
          },
          {
            name: "Custom instrumentation",
            activePath: "/nodejs/3.x/instrumentation",
            pages: [
              {
                name: "Overview",
                link: "/nodejs/3.x/instrumentation.html",
              },
              {
                name: "Instrumentation",
                link: "/nodejs/3.x/instrumentation/instrumentation.html",
              },
              {
                name: "Additional instrumentations",
                link: "/nodejs/3.x/instrumentation/additional-instrumentations.html",
              },
              {
                name: "Exception handling",
                link: "/nodejs/3.x/instrumentation/exception-handling.html",
              },
              {
                name: "Minutely probes",
                link: "/nodejs/3.x/instrumentation/minutely-probes.html",
              },
            ],
          },
          {
            name: "Integrations",
            activePath: "/nodejs/3.x/integrations",
            pages: [
              {
                name: "Overview",
                link: "/nodejs/3.x/integrations.html",
              },
              {
                name: "amqplib",
                link: "/nodejs/3.x/integrations/amqplib.html",
              },
              {
                name: "Apollo Gateway",
                link: "/nodejs/3.x/integrations/apollo-gateway.html",
              },
              {
                name: "BullMQ",
                link: "/nodejs/3.x/integrations/bullmq.html",
              },
              {
                name: "Express",
                link: "/nodejs/3.x/integrations/express.html",
              },
              {
                name: "Fastify",
                link: "/nodejs/3.x/integrations/fastify.html",
              },
              {
                name: "GraphQL",
                link: "/nodejs/3.x/integrations/graphql.html",
              },
              {
                name: "Knex.js",
                link: "/nodejs/3.x/integrations/knexjs.html",
              },
              {
                name: "Koa.js",
                link: "/nodejs/3.x/integrations/koajs.html",
              },
              {
                name: "MongoDB",
                link: "/nodejs/3.x/integrations/mongo.html",
              },
              {
                name: "Mongoose",
                link: "/nodejs/3.x/integrations/mongoose.html",
              },
              {
                name: "MySQL",
                link: "/nodejs/3.x/integrations/mysql.html",
              },
              {
                name: "NestJS",
                link: "/nodejs/3.x/integrations/nestjs.html",
              },
              {
                name: "Next.js",
                link: "/nodejs/3.x/integrations/nextjs.html",
              },
              {
                name: "Node.js Core",
                link: "/nodejs/3.x/integrations/core.html",
              },
              {
                name: "PostgreSQL",
                link: "/nodejs/3.x/integrations/pg.html",
              },
              {
                name: "Prisma",
                link: "/nodejs/3.x/integrations/prisma.html",
              },
              {
                name: "Redis",
                link: "/nodejs/3.x/integrations/redis.html",
              },
              {
                name: "Remix",
                link: "/nodejs/3.x/integrations/remix.html",
              },
              {
                name: "Restify",
                link: "/nodejs/3.x/integrations/restify.html",
              },
            ],
          },
          {
            name: "Command line tools",
            activePath: "/nodejs/3.x/command-line",
            pages: [
              {
                name: "Overview",
                link: "/nodejs/3.x/command-line.html",
              },
              {
                name: "Diagnose",
                link: "/nodejs/3.x/command-line/diagnose.html",
              },
              {
                name: "Demo",
                link: "/nodejs/3.x/command-line/demo.html",
              },
            ],
          },
        ],
      },
      {
        name: "AppSignal for Front-end",
        icon: faJsSquare,
        activePath: "/front-end",
        pages: [
          {
            name: "Overview",
            link: "/front-end.html",
          },
          {
            name: "Installation",
            link: "/front-end/installation.html",
          },
          {
            name: "Configuration",
            link: "/front-end/configuration.html",
          },
          {
            name: "Error handling",
            link: "/front-end/error-handling.html",
          },
          {
            name: "Creating and Using a Span",
            link: "/front-end/span.html",
          },
          {
            name: "Hooks",
            link: "/front-end/hooks.html",
          },
          {
            name: "Breadcrumbs",
            link: "/front-end/breadcrumbs.html",
          },
          {
            name: "Sourcemaps",
            link: "/front-end/sourcemaps.html",
          },
          {
            name: "Integrations",
            activePath: "/front-end/integrations",
            pages: [
              {
                name: "Overview",
                link: "/front-end/integrations.html",
              },
              {
                name: "React",
                link: "/front-end/integrations/react.html",
              },
              {
                name: "Vue",
                link: "/front-end/integrations/vue.html",
              },
              {
                name: "Angular",
                link: "/front-end/integrations/angular.html",
              },
              {
                name: "Ember",
                link: "/front-end/integrations/ember.html",
              },
              {
                name: "Preact",
                link: "/front-end/integrations/preact.html",
              },
              {
                name: "Stimulus",
                link: "/front-end/integrations/stimulus.html",
              },
            ],
          },
          {
            name: "Plugins",
            activePath: "/front-end/plugins",
            pages: [
              {
                name: "Overview",
                link: "/front-end/plugins.html",
              },
              {
                name: "plugin-breadcrumbs-console",
                link: "/front-end/plugins/plugin-breadcrumbs-console.html",
              },
              {
                name: "plugin-breadcrumbs-network",
                link: "/front-end/plugins/plugin-breadcrumbs-network.html",
              },
              {
                name: "plugin-window-events",
                link: "/front-end/plugins/plugin-window-events.html",
              },
              {
                name: "plugin-path-decorator",
                link: "/front-end/plugins/plugin-path-decorator.html",
              },
            ],
          },
          {
            name: "Troubleshooting",
            link: "/front-end/troubleshooting.html",
          },
        ],
      },
      {
        name: "AppSignal for Python",
        icon: faPython,
        activePath: "/python",
        pages: [
          {
            name: "Overview",
            link: "/python",
          },
          {
            name: "Installation",
            link: "/python/installation",
          },
          {
            name: "Configuration",
            activePath: "/python/configuration",
            pages: [
              {
                name: "Overview",
                link: "/python/configuration.html",
              },
              {
                name: "Options",
                link: "/python/configuration/options.html",
              },
              {
                name: "Load order",
                link: "/python/configuration/load-order.html",
              },
            ],
          },
          {
            name: "Custom instrumentation",
            activePath: "/python/instrumentation",
            pages: [
              {
                name: "Overview",
                link: "/python/instrumentation.html",
              },
              {
                name: "Instrumentation",
                link: "/python/instrumentation/instrumentation.html",
              },
              {
                name: "Exception handling",
                link: "/python/instrumentation/exception-handling.html",
              },
              {
                name: "Minutely probes",
                link: "/python/instrumentation/minutely-probes.html",
              },
            ],
          },
          {
            name: "Instrumentations",
            link: "/python/instrumentations",
            activePath: "/python/instrumentations",
            pages: [
              {
                name: "Overview",
                link: "/python/instrumentations",
              },
              {
                name: "Celery",
                link: "/python/instrumentations/celery.html",
              },
              {
                name: "Django",
                link: "/python/instrumentations/django.html",
              },
              {
                name: "Flask",
                link: "/python/instrumentations/flask.html",
              },
              {
                name: "FastAPI",
                link: "/python/instrumentations/fastapi.html",
              },
              {
                name: "Jinja2",
                link: "/python/instrumentations/jinja2.html",
              },
              {
                name: "MySQL",
                link: "/python/instrumentations/mysql.html",
              },
              {
                name: "Pika",
                link: "/python/instrumentations/pika.html",
              },
              {
                name: "PostgreSQL",
                link: "/python/instrumentations/postgresql.html",
              },
              {
                name: "Redis",
                link: "/python/instrumentations/redis.html",
              },
              {
                name: "Requests",
                link: "/python/instrumentations/requests.html",
              },
              {
                name: "Starlette",
                link: "/python/instrumentations/starlette.html",
              },
              {
                name: "SQLAlchemy",
                link: "/python/instrumentations/sqlalchemy.html",
              },
              {
                name: "SQLite",
                link: "/python/instrumentations/sqlite.html",
              },
              {
                name: "WSGI/ASGI",
                link: "/python/instrumentations/wsgi.html",
              },
            ],
          },
          {
            name: "Command line tools",
            activePath: "/python/command-line",
            pages: [
              {
                name: "Overview",
                link: "/python/command-line.html",
              },
              {
                name: "Install",
                link: "/python/command-line/install.html",
              },
              {
                name: "Diagnose",
                link: "/python/command-line/diagnose.html",
              },
              {
                name: "Demo",
                link: "/python/command-line/demo.html",
              },
            ],
          },
        ],
      },
      {
        name: "AppSignal for Go <sup>New</sup>",
        icon: faGolang,
        activePath: "/go",
        pages: [
          {
            name: "Overview",
            link: "/go",
          },
          {
            name: "Installation",
            link: "/go/installation.html",
          },
          {
            name: "Configuration",
            activePath: "/go/configuration",
            link: "/go/configuration.html",
            pages: [
              {
                name: "Overview",
                link: "/go/configuration.html",
              },
              {
                name: "Options",
                link: "/go/configuration/options.html",
              },
            ],
          },
          {
            name: "Instrumentations",
            link: "/go/instrumentations.html",
            activePath: "/go/instrumentations",
            pages: [
              {
                name: "Overview",
                link: "/go/instrumentations.html",
              },
              {
                name: "Gin-gonic",
                link: "/go/instrumentations/gin-gonic.html",
              },
              {
                name: "Gorilla mux",
                link: "/go/instrumentations/gorilla-mux.html",
              },
              {
                name: "Mongo",
                link: "/go/instrumentations/mongo.html",
              },
              {
                name: "Redis",
                link: "/go/instrumentations/redis.html",
              },
              {
                name: "SQL",
                link: "/go/instrumentations/sql.html",
              },
            ],
          },
          {
            name: "Custom instrumentation",
            link: "/go/custom-instrumentation.html",
          },
        ],
      },
      {
        name: "AppSignal for Java <sup>New</sup>",
        icon: faJava,
        activePath: "/java",
        pages: [
          {
            name: "Overview",
            link: "/java",
          },
          {
            name: "Installation",
            link: "/java/installation.html",
          },
          {
            name: "Configuration",
            activePath: "/java/configuration",
            link: "/java/configuration.html",
            pages: [
              {
                name: "Overview",
                link: "/java/configuration.html",
              },
              {
                name: "Options",
                link: "/java/configuration/options.html",
              },
            ],
          },
          {
            name: "Custom instrumentation",
            link: "/java/custom-instrumentation.html",
          },
        ],
      },
      {
        name: "AppSignal for PHP <sup>New</sup>",
        icon: faPhp,
        activePath: "/php",
        pages: [
          {
            name: "Overview",
            link: "/php",
          },
          {
            name: "Installation",
            link: "/php/installation.html",
          },
          {
            name: "Configuration",
            activePath: "/php/configuration",
            link: "/php/configuration.html",
            pages: [
              {
                name: "Overview",
                link: "/php/configuration.html",
              },
              {
                name: "Options",
                link: "/php/configuration/options.html",
              },
            ],
          },
          {
            name: "Custom instrumentation",
            link: "/php/custom-instrumentation.html",
          },
        ],
      },
      {
        name: "OpenTelemetry <sup>New</sup>",
        icon: faTelescope,
        activePath: "/opentelemetry",
        pages: [
          {
            name: "Overview",
            activePath: "/opentelemetry",
            link: "/opentelemetry",
          },
          {
            name: "Installation",
            activePath: "/opentelemetry/installation",
            pages: [
              {
                name: "Overview",
                link: "/opentelemetry/installation.html",
              },
              {
                name: "Ruby",
                link: "/opentelemetry/installation/ruby.html",
              },
              {
                name: "Elixir",
                link: "/opentelemetry/installation/elixir.html",
              },
              {
                name: "Node.js",
                link: "/opentelemetry/installation/nodejs.html",
              },
              {
                name: "Python",
                link: "/opentelemetry/installation/python.html",
              },
              {
                name: "Java",
                link: "/java/installation.html",
              },
              {
                name: "Go",
                link: "/go/installation.html",
              },
              {
                name: "PHP",
                link: "/php/installation.html",
              },
              {
                name: "Vercel",
                link: "/opentelemetry/installation/vercel.html",
              },
              {
                name: "Other",
                link: "/opentelemetry/installation/generic.html",
              },
            ],
          },
          {
            name: "Configuration",
            activePath: "/opentelemetry/configuration",
            pages: [
              {
                name: "Overview",
                link: "/opentelemetry/configuration.html",
              },
              {
                name: "Options",
                link: "/opentelemetry/configuration/options.html",
              },
            ],
          },
          {
            name: "Custom instrumentation",
            activePath: "/opentelemetry/custom-instrumentation",
            link: "/opentelemetry/custom-instrumentation",
            pages: [
              {
                name: "Overview",
                link: "/opentelemetry/custom-instrumentation.html",
              },
              {
                name: "Attributes",
                link: "/opentelemetry/custom-instrumentation/attributes.html",
              },
            ],
          },
          {
            name: "Troubleshooting",
            link: "/opentelemetry/troubleshooting.html",
          },
        ],
      },
    ],
  },
  {
    name: "Features",
    sub_sections: [
      {
        name: "Uptime monitoring",
        icon: faTrafficLight,
        activePath: "/uptime-monitoring",
        pages: [
          {
            name: "Setup",
            link: "/uptime-monitoring/setup.html",
          },
          {
            name: "Public status page <sup>New</sup>",
            activePath: "/uptime-monitoring",
            pages: [
              {
                name: "Public status page",
                link: "/uptime-monitoring/public-status-page.html",
              },
              {
                name: "Custom Domain <sup>New</sup>",
                link: "/uptime-monitoring/public-status-page/custom-domain.html",
              },
            ],
          },
        ],
      },
      {
        name: "Anomaly detection",
        icon: faBell,
        link: "/anomaly-detection",
      },
      {
        name: "Check-ins <sup>BETA</sup>",
        icon: faCheckSquare,
        link: "/check-ins",
        activePath: "/check-ins",
        pages: [
          {
            name: "Overview",
            link: "/check-ins",
          },
          {
            name: "Create a check-in",
            link: "/check-ins/create.html",
          },
          {
            name: "Configuration",
            activePath: "/check-ins/configuration",
            pages: [
              {
                name: "Overview",
                link: "/check-ins/configuration/",
              },
              {
                name: "API",
                link: "/check-ins/configuration/api.html",
              },
              {
                name: "Integrations",
                link: "/check-ins/configuration/integrations.html",
              },
              {
                name: "Wrap process monitoring",
                link: "/wrap#check-ins",
              },
            ],
          },
          {
            name: "Check-in occurrences",
            link: "/check-ins/occurrences.html",
          },
        ],
      },
      {
        name: "Logging <sup>New</sup>",
        icon: faLineColumns,
        activePath: "/logging",
        pages: [
          {
            name: "Overview",
            link: "/logging.html",
          },
          {
            name: "Configure Logging",
            link: "/logging/configuration.html",
          },
          {
            name: "Integrations",
            activePath: "/logging/integrations",
            pages: [
              {
                name: "Overview",
                link: "/logging/integrations.html",
              },
              {
                name: "Ruby",
                link: "/logging/integrations/ruby.html",
              },
              {
                name: "Elixir",
                link: "/logging/integrations/elixir.html",
              },
              {
                name: "Node.js",
                link: "/logging/integrations/nodejs.html",
              },
              {
                name: "Wrap process monitoring",
                link: "/wrap#logging",
              },
            ],
          },
          {
            name: "Platforms",
            activePath: "/logging/platforms",
            pages: [
              {
                name: "Overview",
                link: "/logging/platforms.html",
              },
              {
                name: "AWS Kinesis / CloudWatch",
                link: "/logging/platforms/cloudwatch.html",
              },
              {
                name: "Clever Cloud",
                link: "/logging/platforms/clevercloud.html",
              },
              {
                name: "Gigalixir Log Drain",
                link: "/logging/platforms/gigalixir.html",
              },
              {
                name: "Heroku Log Drain",
                link: "/logging/platforms/heroku.html",
              },
              {
                name: "Netlify",
                link: "/logging/platforms/netlify.html",
              },
              {
                name: "Render",
                link: "/logging/platforms/render.html",
              },
              {
                name: "Scalingo Log Drain",
                link: "/logging/platforms/scalingo.html",
              },
              {
                name: "Vector",
                link: "/logging/platforms/vector.html",
              },
              {
                name: "Vercel",
                link: "/logging/platforms/vercel.html",
              },
            ],
          },
          {
            name: "Formatting",
            activePath: "/logging/formatting",
            pages: [
              {
                name: "Overview",
                link: "/logging/formatting.html",
              },
              {
                name: "Logfmt",
                link: "/logging/formatting/logfmt.html",
              },
              {
                name: "JSON",
                link: "/logging/formatting/json.html",
              },
            ],
          },
          {
            name: "Endpoints",
            activePath: "/logging/endpoints",
            pages: [
              {
                name: "Overview",
                link: "/logging/endpoints.html",
              },
              {
                name: "HTTP",
                link: "/logging/endpoints/http.html",
              },
              {
                name: "HTTP-JSON",
                link: "/logging/endpoints/http-json.html",
              },
              {
                name: "HTTP-Syslog",
                link: "/logging/endpoints/http-syslog.html",
              },
              {
                name: "Syslog",
                link: "/logging/endpoints/syslog.html",
              },
            ],
          },
          {
            name: "Log Management",
            link: "/logging/log-management.html",
          },
          {
            name: "Triggers",
            link: "/logging/triggers.html",
          },
          {
            name: "Troubleshooting",
            link: "/logging/troubleshooting.html",
          },
          {
            name: "Long-term Log Storage <sup>new</sup>",
            link: "/logging/long-term-log-storage.html",
          },
        ],
      },
      {
        name: "Metrics",
        icon: faChartArea,
        activePath: "/metrics",
        pages: [
          {
            name: "Custom metrics",
            link: "/metrics/custom.html",
          },
          {
            name: "NGINX metrics",
            link: "/metrics/nginx.html",
          },
          {
            name: "Host metrics",
            activePath: "/metrics/host-metrics",
            pages: [
              {
                name: "Overview",
                link: "/metrics/host-metrics.html",
              },
              {
                name: "Heroku host metrics",
                link: "/heroku/host-metrics.html",
              },
              {
                name: "Container host metrics",
                link: "/metrics/host-metrics/containers.html",
              },
            ],
          },
          {
            name: "Dashboards",
            link: "/metrics/dashboards.html",
          },
        ],
      },
      {
        name: "AppSignal API",
        icon: faWebhook,
        activePath: "/api",
        pages: [
          {
            name: "Overview",
            link: "/api.html",
          },
          {
            name: "GraphQL",
            activePath: "/api/graphql-explorer.html",
            pages: [
              {
                name: "Examples",
                link: "/api/graphql-explorer-examples.html",
              },
            ],
          },
          {
            name: "Graphs",
            link: "/api/graphs.html",
          },
          {
            name: "Markers",
            link: "/api/markers.html",
          },
          {
            name: "Samples",
            link: "/api/samples.html",
          },
          {
            name: "Event names",
            link: "/api/event-names.html",
          },
          {
            name: "Sourcemaps",
            link: "/api/sourcemaps.html",
          },
          {
            name: "Public endpoint",
            activePath: "/api/public-endpoint",
            pages: [
              {
                name: "Overview",
                link: "/api/public-endpoint.html",
              },
              {
                name: "StatsD",
                link: "/api/public-endpoint/statsd.html",
              },
              {
                name: "JSON Metrics",
                link: "/api/public-endpoint/json-metrics.html",
              },
              {
                name: "Errors",
                link: "/api/public-endpoint/errors.html",
              },
              {
                name: "Custom markers",
                link: "/api/public-endpoint/custom-markers.html",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    name: "Services & Integrations",
    sub_sections: [
      {
        name: "Heroku",
        icon: faLink,
        activePath: "/heroku",
        pages: [
          {
            name: "Setup",
            link: "/heroku/setup.html",
          },
          {
            name: "Logplex errors",
            link: "/heroku/logplex-errors.html",
          },
          {
            name: "Host metrics",
            link: "/heroku/host-metrics.html",
          },
          {
            name: "Dashboards",
            link: "/heroku/dashboards.html",
          },
          {
            name: "Deploy Markers",
            link: "/heroku/deploys.html",
          },
        ],
      },
      {
        name: "Vector",
        icon: faLink,
        activePath: "/vector",
        pages: [
          {
            name: "Overview",
            link: "/vector.html",
          },
          {
            name: "MongoDB",
            link: "/vector/mongodb.html",
          },
          {
            name: "PostgreSQL",
            link: "/vector/postgresql.html",
          },
        ],
      },
      {
        name: "Kubernetes <sup>New</sup>",
        icon: faLink,
        activePath: "/kubernetes",
        pages: [
          {
            name: "Metrics",
            link: "/kubernetes/metrics.html",
          },
        ],
      },
    ],
  },
  {
    name: "Tools",
    sub_sections: [
      {
        name: "Wrap <sup>New</sup>",
        icon: faCode,
        link: "/wrap",
      },
      {
        name: "Collector <sup>New</sup>",
        icon: faPipeValve,
        activePath: "/collector",
        pages: [
          {
            name: "Overview",
            link: "/collector",
          },
          {
            name: "Installation",
            activePath: "/collector/installation",
            pages: [
              {
                name: "Overview",
                link: "/collector/installation.html",
              },
              {
                name: "Linux package",
                link: "/collector/installation/linux-package.html",
              },
              {
                name: "Docker image",
                link: "/collector/installation/docker-image.html",
              },
              {
                name: "Platform as a Service",
                link: "/collector/installation/platform-as-a-service.html",
              },
            ],
          },
          {
            name: "Configuration",
            activePath: "/collector/configuration",
            pages: [
              {
                name: "Overview",
                link: "/collector/configuration.html",
              },
              {
                name: "Options",
                link: "/collector/configuration/options.html",
              },
            ],
          },
        ],
      },
      {
        name: "Standalone agent",
        icon: faUserSecret,
        activePath: "/standalone-agent",
        pages: [
          {
            name: "Installation",
            link: "/standalone-agent/installation.html",
            activePath: "/standalone-agent/installation",
            pages: [
              {
                name: "Overview",
                link: "/standalone-agent/installation.html",
              },
              {
                name: "Linux package",
                link: "/standalone-agent/installation/linux-package.html",
              },
              {
                name: "Docker image",
                link: "/standalone-agent/installation/docker-image.html",
              },
            ],
          },
          {
            name: "Configuration",
            link: "/standalone-agent/configuration.html",
            activePath: "/standalone-agent/configuration",
            pages: [
              {
                name: "Overview",
                link: "/standalone-agent/configuration.html",
              },
              {
                name: "Configuration options",
                link: "/standalone-agent/configuration/options.html",
              },
              {
                name: "Load order",
                link: "/standalone-agent/configuration/load-order.html",
              },
            ],
          },
          {
            name: "StatsD Metrics",
            link: "/standalone-agent/statsd.html",
          },
        ],
      },
      {
        name: "MCP Server <sup>Beta</sup>",
        icon: faCogs,
        link: "/mcp",
      },
    ],
  },
  {
    name: "More",
    sub_sections: [
      {
        name: "Support",
        icon: faQuestionCircle,
        activePath: "/support",
        pages: [
          {
            name: "Overview",
            link: "/support.html",
          },
          {
            name: "Billing",
            activePath: "/support/billing",

            pages: [
              {
                name: "Overview",
                link: "/support/billing.html",
              },
              {
                name: "Invoicing",
                link: "/support/billing/invoicing.html",
              },
              {
                name: "Usage",
                link: "/support/billing/usage.html",
              },
            ],
          },
          {
            name: "Business add-ons",
            link: "/support/business-add-ons.html",
          },
          {
            name: "Contact us",
            link: "mailto:support@appsignal.com",
          },
          {
            name: "Debugging AppSignal",
            link: "/support/debugging.html",
          },
          {
            name: "Supported Operating Systems",
            link: "/support/operating-systems.html",
          },
          {
            name: "Maintenance policy",
            link: "/support/maintenance-policy.html",
          },
          {
            name: "Limiting requests",
            link: "/support/limiting-requests.html",
          },
          {
            name: "Known issues",
            link: "/support/known-issues.html",
          },
          {
            name: "About time",
            link: "/support/about-time.html",
          },
          {
            name: "Service status page",
            link: "https://status.appsignal.com",
          },
        ],
      },
      {
        name: "About AppSignal",
        icon: faInfoCircle,
        activePath: "/appsignal",
        pages: [
          {
            name: "Contributing",
            activePath: "/appsignal/contributing",
            pages: [
              {
                name: "Overview",
                link: "/appsignal/contributing.html",
              },
              {
                name: "Code of Conduct",
                link: "/appsignal/contributing/code-of-conduct.html",
              },
            ],
          },
          {
            name: "Security",
            link: "/appsignal/security.html",
          },
          {
            name: "GDPR",
            link: "/appsignal/gdpr.html",
          },
          {
            name: "How our integrations operate",
            link: "/appsignal/how-appsignal-operates.html",
          },
          {
            name: "Life cycle of app data",
            link: "/appsignal/data-life-cycle.html",
          },
          {
            name: "Terminology",
            link: "/appsignal/terminology.html",
          },
        ],
      },
    ],
  },
];

export default navigationLinks;
